import cookie from 'react-cookie';
import { defaultCountryIso2 } from '../data/locale';

export const setPreferredLocale = (localeIso2) => {
  cookie.save('ldt_userSelectedLocale', localeIso2, {
    // Matching params are required to set the cookie
    domain: window.location.hostname,
    path: '/',
    expires: new Date(2147483647000),
  });
};

export const getPreferredLocale = ({ userSelectedLocale, localeInUrl }) => {
  if (userSelectedLocale) {
    return userSelectedLocale;
  }
  if (localeInUrl) {
    return localeInUrl;
  }
  return defaultCountryIso2;
};
